import { graphql } from "@/lib/gql/__generated__";

export const SEND_SAMPLE_EMAIL_REQUEST_RESERVATION_CONFIRMED_MUTATION = graphql(`
	mutation TestEmailRequestReservationAtConfirmed($input: TestEmailInput!) {
		testEmailRequestReservationAtConfirmed(input: $input) {
			userErrors
			status
		}
	}
`);
